const carrierUserFormDefaultValues = {
  phone: '',
  first_name: '',
  email: '',
  language: 'en-GB',
  carrier_user_groups: [],
};

export default carrierUserFormDefaultValues;
